export default __webpack_public_path__ + "static/media/pin.3bbff487.png";